import { useState, useEffect} from 'react';


// MUI and Material Dashboard Components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MDBox from 'components/MDBox';
import FormControl from '@mui/material/FormControl';
import MDTypography from 'components/MDTypography';

export default function CustomTextDialog({
    handleClose,
    open,
    part,
    name
}) {
    const [customText, setCustomText] = useState("");

    useEffect(() => {
        if (name) {
            const attName = name.split(".")[1];
            const attValue = part.attributes ? part.attributes[attName] : "";
            setCustomText(attValue);
        }
    }, [name])
    
    const onSubmit = () => {
        setCustomText("");
        handleClose(customText);
    }

    const onCancel = () => {
        setCustomText("");
        handleClose();
    }

    return (
        <Dialog
            open={open}
            onClose={onCancel}
        >
            <DialogTitle>Other Value</DialogTitle>

            <DialogContent>

                <MDBox>
                    <MDTypography
                        variant="body2"
                        color="text"
                        fontWeight="light"
                        mb={1}
                    >
                        Please enter the required value for this attribute.
                    </MDTypography>
                </MDBox>

                <MDBox>
                    <FormControl fullWidth>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Other Value"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={customText}
                            onChange={(e) => setCustomText(e.target.value)}
                        />
                    </FormControl>
                </MDBox>

            </DialogContent>
            <DialogActions>

                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onSubmit}>Save</Button>

            </DialogActions>

        </Dialog>
    )
}